import {useAuth0} from '@auth0/auth0-react';
import NotificationAction from 'Components/Atoms/NotificationAction/NotificationAction';
import CooperationConditionDocument
	from 'Components/Templates/Document/CooperationCondition/CooperationConditionDocument';
import TalentProposalDocument from 'Components/Templates/Document/TalentProposal/TalentProposalDocument';
import jwt_decode from 'jwt-decode';
import BusinessUnitOverviewPage from 'Pages/Dashboard/BusinessUnit/BusinessUnitOverviewPage';
import BusinessUnitPage from 'Pages/Dashboard/BusinessUnit/BusinessUnitPage';
import CandidateOverviewPage from 'Pages/Dashboard/Candidate/CandidateOverviewPage';
import CandidatePage from 'Pages/Dashboard/Candidate/CandidatePage';
import ContactOverviewPage from 'Pages/Dashboard/Contact/ContactOverviewPage';
import ContactPage from 'Pages/Dashboard/Contact/ContactPage';
import DashboardPage from 'Pages/Dashboard/Dashboard/DashboardPage';
import EntityCreatePage from 'Pages/Dashboard/EntityCreate/EntityCreatePage';
import EntitiesPage from 'Pages/Dashboard/Settings/Entities/EntitiesPage';
import EntityPage from 'Pages/Dashboard/Settings/Entities/EntityPage';
import LayoutPage from 'Pages/Dashboard/Settings/Entities/Layouts/LayoutPage';
import LayoutTypeMenuPage from 'Pages/Dashboard/Settings/Entities/Layouts/LayoutTypeMenuPage';
import ContactModulePage from 'Pages/Dashboard/Settings/Entities/Modules/ContactModule/ContactModulePage';
import ModulesPage from 'Pages/Dashboard/Settings/Entities/Modules/ModulesPage';
import ExtensionsSettingsPage from 'Pages/Dashboard/Settings/Extensions/ExtensionsSettingsPage';
import MailgunExtensionPage from 'Pages/Dashboard/Settings/Extensions/MailgunExtensionPage';
import DatasetsPage from 'Pages/Dashboard/Settings/FieldsManagement/Datasets/DatasetsPage';
import FieldsPage from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldsPage';
import RelationPage from 'Pages/Dashboard/Settings/FieldsManagement/Relations/RelationPage';
import SettingsPage from 'Pages/Dashboard/Settings/SettingsPage';
import UsersPage from 'Pages/Dashboard/Settings/Users/UsersPage';
import VacancyOverviewPage from 'Pages/Dashboard/Vacancy/VacancyOverviewPage';
import VacancyPage from 'Pages/Dashboard/Vacancy/VacancyPage';
import {BlockedPage} from 'Pages/Error/BlockedPage/BlockedPage';
import NoRolePage from 'Pages/Error/NoRolePage/NoRolePage';
import {NotFoundPage} from 'Pages/Error/NotFoundPage/NotFoundPage';
import {UnauthorizedPage} from 'Pages/Error/UnauthorizedPage/UnauthorizedPage';
import {LoadingPage} from 'Pages/Shared/LoadingPage';
import {AuthCallbackPage} from 'Pages/Unauthorized/AuthCallbackPage';
import {LoginPage} from 'Pages/Unauthorized/LoginPage';
import {LogoutPage} from 'Pages/Unauthorized/LogoutPage';
import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Route, Routes, useLocation} from 'react-router-dom';
import Permissions from 'Services/Authentication/Permissions/Permissions.types';
import ProtectedRoute from 'Services/Authentication/ProtectedRoute';
import {ROUTE, ROUTES} from 'Services/Route/Route.types';
import EntitiesPageOld from 'Pages/Dashboard/Settings/Entities/EntitiesPageOld';
import DocumentGeneratorPage from 'Pages/Dashboard/Settings/Entities/Modules/DocumentGenerator/DocumentGeneratorPage';
import MailsPage from 'Pages/Dashboard/Mails/MailsPage';
import OptionsPage from 'Pages/Dashboard/Options/OptionsPage';
import ProfilePage from 'Pages/Dashboard/User/ProfilePage';
import OfferOverviewPage from 'Pages/Dashboard/Offer/OfferOverviewPage';
import OfferPage from 'Pages/Dashboard/Offer/OfferPage';
import BlogList from 'Pages/Blog/BlogList';
import BlogForm from 'Pages/Blog/BlogForm';
import BlogEdit from 'Pages/Blog/BlogEdit';
import CategoryList from 'Pages/Blog/CategoryList';
import CategoryForm from 'Pages/Blog/CategoryForm';
import BlogCreate from 'Pages/Blog/BlogCreate';
import CategoryCreate from 'Pages/Blog/CategoryCreate';

const App = (props: any) => {
	const { pathname } = useLocation();
	const { getAccessTokenSilently, isLoading, error, isAuthenticated, loginWithRedirect } = useAuth0();

	const [state, setState] = useState<'loading'|'roleless'|'role'>('loading');
	const roleValidation = async () => {
		
		const data = await getAccessTokenSilently();
		localStorage.setItem(window.btoa('accessToken'), window.btoa(data));

		const decodedToken = jwt_decode(data);
		console.log('🔑 Decoded Token:', decodedToken);
		// if (decodedToken?.['https://app.growing-people.nl/roles']?.length > 0) {
			setState('role');
			return;
		// }

		setState('roleless');
	}

	useEffect(() => {
		if (isLoading) return;

		if (!isAuthenticated) {
			loginWithRedirect();
			return;
		}

		roleValidation();
	}, [isLoading]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	if (isLoading) {
		return <LoadingPage />;
	} 

	if (error && error?.message.includes('block')) {
		return <BlockedPage />;
	}

	if (error) {
		return <UnauthorizedPage />;
	}

	if (state === 'roleless') {
		return <NoRolePage />;
	}

	if (state === 'role') {
		return <>
			<NotificationAction/>
			<Routes>
				<Route
					path='/document/cooperation_condition/:id'
					element={<ProtectedRoute component={CooperationConditionDocument}/>}
				/>
				<Route
					path='/document/:entity_id/talent_proposal/:file_id'
					element={<ProtectedRoute component={TalentProposalDocument}/>}
				/>

				<Route
					path={ROUTE.DASHBOARD}
					element={<ProtectedRoute component={DashboardPage}/>}
				/>

				<Route
					path={ROUTES.MAILS.getFullPath()}
					element={<ProtectedRoute component={MailsPage}/>}
				/>

				<Route
					path={ROUTES.OPTIONS.getFullPath()}
					element={<ProtectedRoute component={OptionsPage}/>}
				/>

				{/* ENTITY CREATE */}
				<Route
					path={ROUTES.CREATE.path}
					element={<ProtectedRoute component={EntityCreatePage}/>}
				/>

				{/* VACANCIES */}
				<Route
					path={ROUTES.VACANCIES.path}
					element={<ProtectedRoute component={VacancyOverviewPage}/>}
				/>
				<Route
					path={ROUTES.VACANCIES.DETAILED.getFullPath()}
					element={<ProtectedRoute component={VacancyPage}/>}
				/>

				{/* OFFERS */}
				<Route
					path={ROUTES.OFFERS.path}
					element={<ProtectedRoute component={OfferOverviewPage}/>}
				/>
				<Route
					path={ROUTES.OFFERS.DETAILED.getFullPath()}
					element={<ProtectedRoute component={OfferPage}/>}
				/>

				{/* CANDIDATES */}
				<Route
					path={ROUTES.CANDIDATES.path}
					element={<ProtectedRoute component={CandidateOverviewPage}/>}
				/>
				<Route
					path={ROUTES.CANDIDATES.DETAILED.getFullPath()}
					element={<ProtectedRoute component={CandidatePage}/>}
				/>

				{/* COMPANIES */}
				<Route
					path={ROUTES.BUSINESS_UNITS.path}
					element={<ProtectedRoute component={BusinessUnitOverviewPage}/>}
				/>
				<Route
					path={ROUTES.BUSINESS_UNITS.DETAILED.getFullPath()}
					element={<ProtectedRoute component={BusinessUnitPage}/>}
				/>

				{/* CONTACTS */}
				<Route
					path={ROUTES.CONTACTS.path}
					element={<ProtectedRoute component={ContactOverviewPage}/>}
				/>
				<Route
					path={ROUTES.CONTACTS.DETAILED.getFullPath()}
					element={<ProtectedRoute component={ContactPage}/>}
				/>

				{/* SETTINGS */}
				<Route
					path={ROUTES.SETTINGS.path}
					element={<ProtectedRoute
						component={SettingsPage}
						permissions={[
							Permissions.Settings.READ
						]}
					/>}
				/>
				<Route
					path={ROUTES.SETTINGS.EXTENSIONS.getFullPath()}
					element={<ProtectedRoute component={ExtensionsSettingsPage}/>}
				/>

				{/* SETTINGS ENTITIES */}
				<Route
					path={ROUTES.SETTINGS.ENTITIES.getFullPath()}
					element={<ProtectedRoute component={EntitiesPage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath()}
					element={<ProtectedRoute component={EntityPage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.GENERAL.getFullPath()}
					element={<ProtectedRoute component={EntitiesPageOld}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.FIELDS.getFullPath()}
					element={<ProtectedRoute component={FieldsPage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.LAYOUTS.getFullPath()}
					element={<ProtectedRoute component={LayoutTypeMenuPage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.LAYOUTS.TYPES.getFullPath()}
					element={<ProtectedRoute component={LayoutPage}/>}
				/>

				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.CONTACT_MODULE.getFullPath()}
					element={<ProtectedRoute component={ContactModulePage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.DOCUMENT_GENERATOR.getFullPath()}
					element={<ProtectedRoute component={DocumentGeneratorPage} />}
				/>


				<Route
					path={ROUTES.SETTINGS.USERS.getFullPath()}
					element={<ProtectedRoute component={UsersPage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.RELATIONS.getFullPath()}
					element={<ProtectedRoute component={RelationPage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.DATASETS.getFullPath()}
					element={<ProtectedRoute component={DatasetsPage}/>}
				/>
				<Route
					path={ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.getFullPath()}
					element={<ProtectedRoute component={ModulesPage}/>}
				/>
				<Route
					path={ROUTE.SETTING.MAILGUN}
					element={<ProtectedRoute component={MailgunExtensionPage}/>}
				/>

				{/* AUTHENTICATION */}
				<Route
					path={ROUTES.PROFILE.getFullPath()}
					element={<ProtectedRoute component={ProfilePage}/>}
				/>
				<Route
					path={ROUTE.LOGOUT}
					element={<ProtectedRoute component={LogoutPage}/>}
				/>
				<Route
					path={ROUTE.LOGIN}
					element={<LoginPage/>}
				/>
				<Route
					path={ROUTE.AUTH0_CALLBACK}
					element={<AuthCallbackPage/>}
				/>

				{/* BLOG */}
				<Route
					path={ROUTES.BLOG.path}
					element={<ProtectedRoute component={BlogList}/>}
				/>
				<Route
					path="/blog/create"
					element={<ProtectedRoute component={BlogCreate}/>}
				/>
				<Route
					path="/blog/edit/:id"
					element={<ProtectedRoute component={BlogEdit}/>}
				/>

				{/* BLOG CATEGORIES */}
				<Route
					path="/blog/categories"
					element={<ProtectedRoute component={CategoryList}/>}
				/>
				<Route
					path="/blog/categories/create"
					element={<ProtectedRoute component={CategoryCreate}/>}
				/>
				<Route
					path="/blog/categories/edit/:id"
					element={<ProtectedRoute component={CategoryForm}/>}
				/>

				<Route
					path="*"
					element={<NotFoundPage/>}
				/>
			</Routes>
		</>;
	}

	return <LoadingPage />;
}

export default connect(() => ({}), {})(App);